import { render, staticRenderFns } from "./ButtonAdmin.vue?vue&type=template&id=42c3f0be&"
import script from "./ButtonAdmin.vue?vue&type=script&lang=js&"
export * from "./ButtonAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports